import { ResponsivePictureLayout } from '@news-mono/component-library'
import { layout } from '../../App.routing'

const curation = 'federal-election-2022'

export const federalElectionSegment = () => {
    return layout.nestedComposition({
        type: 'thor',
        feature: 'federal-election-2022-federal-collection',
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            themeOverride: 'federal-election',
            verticalSpacing: 'unset',
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'sierra',
                    props: {
                        verticalSpacing: 'gridGap',
                        fixedRatios: ['16:9'],
                        heroImageLayout:
                            ResponsivePictureLayout.ObjectFitContain,
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                            maxBreakpoint: 'md',
                        },
                        cardLayout: ['hero', 'teaser-xsVisible-mdHidden-Image'],

                        dataDefinitionArgs: {
                            type: 'curation',
                            name: curation,
                            offset: 0,
                            pageSize: 2,
                        },
                    },
                }),
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: false,
                        verticalSpacing: 'unset',
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'lima',
                                props: {
                                    section: 'default',
                                    hasBackground: false,
                                    hasBorder: false,
                                    cardLayout: [
                                        [
                                            {
                                                type: 'landscape-stacked',
                                                format: 'landscape-stacked-noteaser',
                                            },
                                            {
                                                type: 'landscape-stacked',
                                                format: 'landscape-stacked-noteaser',
                                            },
                                            {
                                                type: 'landscape-stacked',
                                                format: 'landscape-stacked-noteaser',
                                            },
                                        ],
                                        [
                                            'noImage-noBackground',
                                            'noImage-noBackground',
                                        ],
                                        [
                                            'noImage-noBackground',
                                            'noImage-noBackground',
                                        ],
                                        ['teaserSmallTitle'],
                                    ],
                                    cardOrientation: {
                                        type: 'Landscape-Portrait',
                                    },
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: curation,
                                        offset: 2,
                                        pageSize: 8,
                                    },
                                },
                            }),
                        ],
                    },
                }),
            ],
        },
    })
}
